import * as React from "react";
const { useState, useEffect } = React;
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import http from '../interceptors/httpInterceptor';

const HorizontalNavigation = (props) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [domain, setDomain] = useState('');
    const [isEduScope, setIsEduScope] = useState(false);
    const [sessionLabel, setSessionLabel] = useState('Current Session');
    const [currentSession, setCurrentSession] = useState('');
    const [users, setUsers] = useState([]);
    const [imitationActive, setImitationActive] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');

    // Check if domain belongs to eduScope and get session info
    useEffect(() => {
        // Try to get domain and session from Angular rootScope if available
        const checkDomainAndSession = () => {
            try {
                const element = angular.element(document.querySelector('body'));
                if (element && element.scope) {
                    const rootScope = element.scope().$root;
                    if (rootScope && rootScope.ob) {
                        // Check login state
                        setIsLoggedIn(!rootScope.ob.isLoginOpen && rootScope.loadComplete);

                        // Check domain
                        if (rootScope.ob.domain) {
                            const currentDomain = rootScope.ob.domain;
                            setDomain(currentDomain);
                            const isEdu = rootScope.ob.isEdu;
                            setIsEduScope(isEdu);
                        }

                        // Check session info
                        if (rootScope.ob.session) {
                            setCurrentSession(rootScope.ob.session);
                            setSessionLabel(rootScope.ob.session);
                        }

                        // Check if isEdu is set
                        if (rootScope.ob.isEdu) {
                            setIsEduScope(rootScope.ob.isEdu);
                        }
                    }
                }
            } catch (error) {
                console.log('Could not access Angular scope, checking window location:', error);
                // Fallback to window location
                const hostname = window.location.hostname;
                setDomain(hostname);
                const isEdu = hostname.includes('eduScope') ||
                    hostname.endsWith('.eduScope') ||
                    hostname.includes('eduscope');
                setIsEduScope(isEdu);
            }
        };

        // Initial check
        checkDomainAndSession();

        // Set up interval to check for changes (in case Angular loads later)
        const interval = setInterval(checkDomainAndSession, 1000);

        return () => clearInterval(interval);
    }, []);

    // Function to call AngularJS setEduSession function
    const handleSessionChange = (session) => {
        console.log(session)
        try {
            const element = angular.element(document.querySelector('body'));
            if (element && element.scope) {
                console.log(1)
                const rootScope = element.scope();
                if (rootScope) {
                    console.log(Object.keys(rootScope));
                    console.log(3)
                    setCurrentSession(session);
                    setSessionLabel(session); // Update the session label to reflect the change
                    rootScope.$apply(() => {
                        rootScope.setEduSession(session);
                    });
                }
            }
        } catch (error) {
            console.error('Error calling setEduSession:', error);
        }
    };

    // Function to load users for imitation
    const loadUsers = () => {
        try {
            const element = angular.element(document.querySelector('body'));
            if (element && element.scope) {
                const rootScope = element.scope().$root;
                if (rootScope && rootScope.ob) {
                    // Use AngularJS API to query users
                    http.get("/o/recs/pltf_user?stream=true&project=name,_id,user_name&roles=*teacher&domain=" + rootScope.ob.domain).then((response) => {
                        const mappedUsers = response.data.map(user => ({
                            ...user,
                            id: user._id
                        }));
                        setUsers(mappedUsers);
                    }).catch(error => {
                        console.error('Error loading users:', error);
                    });
                }
            }
        } catch (error) {
            console.error('Error accessing Angular scope for user loading:', error);
        }
    };

    // Function to end imitation
    const endImitation = () => {
        try {
            const element = angular.element(document.querySelector('body'));
            const $injector = angular.element(element).injector();
            const myService = $injector.get('OB');
            if (element && element.scope) {
                const rootScope = element.scope();
                if (rootScope && myService) {
                    rootScope.$apply(() => {
                        myService.end_imitation();
                    });
                    setImitationActive(false);
                    setSelectedUser('');
                    // Also update rootScope imitation status
                    if (rootScope.ob) {
                        rootScope.ob.imitation = false;
                    }
                }
            }
        } catch (error) {
            console.error('Error ending imitation:', error);
        }
    };

    // Function to start imitation
    const startImitation = (userId) => {
        try {
            const element = angular.element(document.querySelector('body'));
            const $injector = angular.element(element).injector();
            const myService = $injector.get('OB');

            if (element && element.scope) {
                const rootScope = element.scope();
                if (rootScope && myService) {
                    rootScope.$apply(() => {
                        myService.imitate(userId);
                    });
                    setImitationActive(true);
                    setSelectedUser(userId);
                    // Also update rootScope imitation status
                    if (rootScope.ob) {
                        rootScope.ob.imitation = true;
                    }
                }
            }
        } catch (error) {
            console.error('Error starting imitation:', error);
        }
    };

    // Load users when component mounts or domain changes
    useEffect(() => {
        if (domain) {
            loadUsers();
        }
    }, [domain]);

    // Check for imitation status from Angular scope
    useEffect(() => {
        const checkImitationStatus = () => {
            try {
                const element = angular.element(document.querySelector('body'));
                if (element && element.scope) {
                    const rootScope = element.scope().$root;
                    if (rootScope && rootScope.ob) {
                        // Check if imitation is active
                        if (rootScope.ob.imitation !== undefined) {
                            setImitationActive(rootScope.ob.imitation);
                        }
                    }
                }
            } catch (error) {
                console.log('Could not access Angular scope for imitation status:', error);
            }
        };

        // Initial check
        checkImitationStatus();

        // Set up interval to check for changes
        const interval = setInterval(checkImitationStatus, 1000);

        return () => clearInterval(interval);
    }, []);

    // Menu items for the horizontal navigation
    const menuItems = [
        {
            key: 'dashboard',
            label: <a href="/">Home</a>,
        },
        // {
        //     key: 'quicklinks',
        //     label: <a href="/">Quick Links</a>,
        // },
        // {
        //     key: 'assist',
        //     label: <a href="/page?pagename=obgenai">Assist</a>,
        // },
        {
            key: 'devzone',
            label: <a href="/page?pagename=devzone">IDE</a>,
        }
    ];

    // Session dropdown menu items
    const sessionMenuItems = [
        {
            key: 'current-header',
            label: <div className="dropdown-header">Current</div>,
            disabled: true,
        },
        {
            key: 'current-session',
            label: <a onClick={() => handleSessionChange(currentSession)}>{currentSession || 'Current Session'}</a>,
        },
        {
            type: 'divider',
        },
        {
            key: 'available-header',
            label: <div className="dropdown-header">Available</div>,
            disabled: true,
        },
        {
            key: '2026-27',
            label: <a onClick={() => handleSessionChange('2026-27')}>2026-27</a>,
        },
        {
            key: '2025-26',
            label: <a onClick={() => handleSessionChange('2025-26')}>2025-26</a>,
        },
        {
            key: '2024-25',
            label: <a onClick={() => handleSessionChange('2024-25')}>2024-25</a>,
        },
        {
            key: '2023-24',
            label: <a onClick={() => handleSessionChange('2023-24')}>2023-24</a>,
        },
        {
            key: '2022-23',
            label: <a onClick={() => handleSessionChange('2022-23')}>2022-23</a>,
        },
        {
            key: '2021-22',
            label: <a onClick={() => handleSessionChange('2021-22')}>2021-22</a>,
        },
        {
            key: '2020-21',
            label: <a onClick={() => handleSessionChange('2020-21')}>2020-21</a>,
        },
        {
            key: '2019-20',
            label: <a onClick={() => handleSessionChange('2019-20')}>2019-20</a>,
        },
        {
            key: '2018-19',
            label: <a onClick={() => handleSessionChange('2018-19')}>2018-19</a>,
        },
        {
            key: '2017-18',
            label: <a onClick={() => handleSessionChange('2017-18')}>2017-18</a>,
        },
        {
            key: '2016-17',
            label: <a onClick={() => handleSessionChange('2016-17')}>2016-17</a>,
        },
    ];

    // Imitation dropdown menu items
    const imitationMenuItems = imitationActive
        ? [
            {
                key: 'end-imitation',
                label: <a onClick={endImitation}>End Imitation</a>,
            }
        ]
        : [
            {
                key: 'users-header',
                label: <div className="dropdown-header">Users</div>,
                disabled: true,
            },
            ...users.map(user => ({
                key: user.id,
                label: <a onClick={() => startImitation(user.id)}>{user.name || user.user_name}</a>,
            }))
        ];

    if (!isLoggedIn) {
        return null;
    }

    return (
        <div className="horizontal-nav-container" style={{
            backgroundColor: '#f5f5f5',
            borderBottom: '1px solid #d9d9d9',
            padding: '0 60px 0 16px',
            display: 'flex',
            alignItems: 'center'
        }}>
            <style>
                {`
                .dropdown-header {
                    padding: 5px 12px;
                    color: rgba(0, 0, 0, 0.45);
                    font-size: 12px;
                    font-weight: 600;
                }
                @media (max-width: 1024px) {
                    .horizontal-nav-container {
                        padding-left: 50px !important;
                    }
                }
                `}
            </style>
            <Menu
                mode="horizontal"
                items={menuItems}
                style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    lineHeight: '46px',
                    flex: 1
                }}
                defaultSelectedKeys={['dashboard']}
            />

            {/* Session Dropdown */}
            {isEduScope && <Dropdown
                menu={{ items: sessionMenuItems }}
                trigger={['click']}
                placement="bottomRight"
            >
                <a
                    className="dropdown-toggle"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '0 16px',
                        height: '46px',
                        cursor: 'pointer',
                        color: 'rgba(0, 0, 0, 0.85)'
                    }}
                >
                    <span style={{ marginRight: '4px' }}>{sessionLabel}</span>
                    {/* <DownOutlined /> */}
                </a>
            </Dropdown>}

            {/* Imitation Dropdown */}
            {isEduScope && <Dropdown
                menu={{ items: imitationMenuItems }}
                trigger={['click']}
                placement="bottomRight"
            >
                <a
                    className="dropdown-toggle"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '0 16px',
                        height: '46px',
                        cursor: 'pointer',
                        color: 'rgba(0, 0, 0, 0.85)'
                    }}
                >
                    <span style={{ marginRight: '4px' }}>
                        {imitationActive ? 'End Imitation' : 'Imitate User'}
                    </span>
                    {/* <DownOutlined /> */}
                </a>
            </Dropdown>}
        </div>
    );
};

export default HorizontalNavigation;
